import React from "react";
import intl from "react-intl-universal";
import cx from "classnames";
import * as S from "./styled";
import { SelectBox } from "components/uikit-adapter";

// Interfaces
interface PaginationProps {
  page: number;
  pageSize: number;
  amount: number;
  refreshSearch: (page: number) => void;
  changePageSize: (pageSize: number) => void;
  component?: React.ReactNode;
}

interface ButtonProps {
  value: string;
  type?: "Primary" | "TextRed" | "XmlNF";
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  width?: string;
  height?: string;
}

// Button Component
const Button: React.FC<ButtonProps> = ({
  value,
  type,
  disabled = false,
  onClick,
  className,
  width,
  height,
}) => (
  <S.StyledButton
    className={cx(className, type)}
    width={width}
    height={height}
    onClick={onClick}
    disabled={disabled}
  >
    {value}
  </S.StyledButton>
);

// Main Pagination Component
const OrdersPagination: React.FC<PaginationProps> = ({
  page,
  pageSize,
  amount,
  refreshSearch,
  changePageSize,
  component
}) => {
  const optionsQuantity = [{ value: 20 }, { value: 50 }, { value: 100 }];

  const getPage = () : number => page + 1;

  const getMaximoDaPagina = (): number => {
    let quantidadeFinal = (page + 1) * pageSize;

    if (quantidadeFinal > amount) {
      quantidadeFinal = amount;
    }

    return quantidadeFinal;
  };

  const getMinimoDaPagina = (): number => {
    const existeRegistros = amount === 0;
    return page * pageSize + (existeRegistros ? 0 : 1);
  };

  const getData = (newPage: number): void => {
    refreshSearch(newPage);
  };

  const isLastPage = Math.ceil(amount / pageSize) === page + 1 || amount === 0;

  return (
    <S.StyledPagination>
      <S.StyledLinesPerPageSection>
        {/* @ts-ignore */}
        <SelectBox
          options={optionsQuantity}
          valueKey="value"
          labelKey="value"
          name="pageSize"
          value={pageSize}
          onChange={(e: any) => changePageSize(Number(e.value))}
          menuPlacement="top"
          data-testid="selectbox-page-size"
        />
        <span>{intl.get("commons.linesPerPage")}</span>
      </S.StyledLinesPerPageSection>

      {component}

      <S.StyledPagesSection>
        <span className="page">
          {intl.get("commons.table.page")}: {getPage()}
        </span>
        <span className="pages">
          {getMinimoDaPagina()} - {getMaximoDaPagina()} {intl.get("commons.table.of")} {amount} {intl.get("commons.table.records")}
        </span>
        <Button
          className="arrow"
          value="<"
          width="50"
          height="50"
          onClick={() => getData(page - 1)}
          disabled={page === 0}
        />
        <Button
          className="arrow"
          value=">"
          width="50"
          height="50"
          onClick={() => getData(page + 1)}
          disabled={isLastPage}
        />
      </S.StyledPagesSection>
    </S.StyledPagination>
  );
};

export default OrdersPagination;
